import type React from 'react';

import formatDistanceStrict from 'date-fns/formatDistanceStrict';
import ru from 'date-fns/locale/ru';
import parseISO from 'date-fns/parseISO';

import { useAvailablePeriod } from '@src/entities/available-periods';

type Props = {
	id: number;
};

export const AvailablePeriodDuration: React.FC<Props> = ({ id }) => {
	const { availablePeriod } = useAvailablePeriod(id);

	return (
		<>
			{availablePeriod &&
				formatDistanceStrict(
					parseISO(availablePeriod.start_time),
					parseISO(availablePeriod.end_time),
					{
						locale: ru,
					}
				)}
		</>
	);
};
